import clsx from 'clsx';

export function ToggleView({
  value,
  onChange,
  isDisabled,
  ...props
}: {
  value: boolean;
  onChange?: (newValue: boolean) => void;
  isDisabled?: boolean;
  [props: string]: unknown;
}) {
  function onToggleClicked() {
    const newValue = !value;

    if (onChange) onChange(newValue);
  }

  const primaryClasses = clsx(
    'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring',
    value ? 'bg-secondary-blue' : 'bg-text-grey',
    props,
  );

  const secondaryClasses = clsx(
    'inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200',
    value ? 'translate-x-5' : 'translate-x-0',
  );

  return (
    <span
      role="checkbox"
      aria-checked="false"
      className={primaryClasses}
      onClick={!isDisabled ? onToggleClicked : () => {}}>
      <span aria-hidden="true" className={secondaryClasses} />
    </span>
  );
}
